import { AppBar, Box, IconButton, Toolbar, useTheme, ListItemButton, ListItemIcon, ListItemText, Typography, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import OpsLogo from "../../img/Ops_Logo.svg"
import OpsAvatarComponent from '../OpsAvatarComponent';
import AuthService from '../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/AuthService';
import { useTranslation } from "react-i18next";
import { CustomTopBarProps } from '../../external/ensolvers-core-frontend-mui/components/Main/AppContainer';
import { drawerWidth, topBarHeight } from './AppContainerStyles';

export const ToolBar = ({ open, setOpen, smallViewport, handleSignOut, isLogged }: CustomTopBarProps) => {
  const FULL_TOP_BAR = true
  const LOGO = OpsLogo

  const theme = useTheme();
  const user = AuthService.getUser();
  const { t } = useTranslation();
 
  return (
    <AppBar
      position="absolute"
      sx={{
        boxShadow: 'none',
        height:`${topBarHeight}px`,
        display: "flex",
        direction:'flex-row', 
        justifyContent:'center',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        backgroundColor: theme.palette.primary.dark,
        "&.MuiPaper-elevation4": {
          boxShadow: "none",
        },
        ...(open && !FULL_TOP_BAR && {
          marginLeft: drawerWidth,
          width: `calc(100% - ${drawerWidth}px)`,
          transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }),
      }}
    >
      <Toolbar sx={{ 
        display: "flex",
        direction:'flex-row', 
        justifyContent:'space-between', 
        }} >
        <Box sx={{ display: "flex", direction:'flex-row'}}>
          <IconButton
            edge="start"
            aria-label="open drawer"
            onClick={() => setOpen(!open)}
            sx={{
              ...(smallViewport ? { marginLeft: -19, marginRight: 32 } : {}),
              ...(open && !FULL_TOP_BAR ? { display: "none" } : {}),
            }}
          >
            <MenuIcon sx={{ height:"24px", width:"24px", color:"#B1AEAE"}} />
          </IconButton>
          <Box component="img" src={LOGO} sx={{ height: 45, marginLeft: 5 }} alt="logo"/>
        </Box>
        <Box sx={{ display: "flex", direction:'flex-row', alignItems:'center'}}>
          <div style={{marginRight: "10px", color: "#B1AEAE"}}>
            {`${user?.firstName} ${user?.lastName}` }
          </div>
          <div>
            <OpsAvatarComponent
              avatarUrl={user?.avatarUrl ?? ""}
                    forceGenericAvatar={true}
                    sx={{ width: "1.7em", height: "1.7em" }}
                  />
          </div>
          <div>
            <ListItemButton onClick={handleSignOut}>
              <ListItemIcon style={{color: "#B1AEAE", minWidth:"25px"}}>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText  style={{color: "#B1AEAE"}} primary={t<string>("Log Out")} />
            </ListItemButton>
          </div>
          {/** TODO enable when model is ready to return also the username from backend  */}
          {isLogged && false && (
            <>
              <Box sx={{ display: "flex", justifyContent: "space-between", flexGrow: 1}}>
                <Box sx={{ marginRight: "2rem" }}>
                  <Typography component="h3" variant="h6" color="inherit" noWrap sx={{ fontWeight: 400, display: "inline",}}>
                    Welcome,{" "}
                  </Typography>
                  <Typography component="h3" variant="h6" color="inherit" noWrap sx={{ display: "inline", paddingBottom: ".15rem", textTransform: "uppercase",}}>
                    User
                  </Typography>
                </Box>
              </Box>

              <Button 
                onClick={handleSignOut} 
                sx={{ color: "#fff",
                fontWeight: "bold",
                background: theme.palette.secondary.dark,
                "&:hover": {
                  background: theme.palette.secondary.main,
                },}}>
                SIGN OUT
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  )
}

